import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";

import Question from "./Question";
import Fieldset from "./Fieldset";
import { JunoLegend } from "./Legend";
import Hint from "./Hint";
import Input from "./Input";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";

const DateOfBirthLegend = styled(JunoLegend)`
  padding-bottom: 0.5rem;
`;

/* stylelint-disable property-no-vendor-prefix */
const DateOfBirthField = styled.div`
  display: inline-block;
  margin-right: var(--juno-space-3);

  label {
    display: block;
  }

  input {
    max-width: 5.4ex;
    padding-right: 0.25em;
  }

  .dateOfBirthYear {
    max-width: 9ex;
  }
`;
/* stylelint-enable property-no-vendor-prefix */

class DateOfBirthQuestion extends Component {
  handleChange = (field) => (event) => {
    const handler = this.props.onChange(field);
    handler({ ...event, target: { ...event.target, value: event.target.value.trim() } });
  };

  handleBlur = (field) => (event) => {
    if (this.props.validate) {
      this.props.validate(field)(event.target.value);
    }
  };

  render() {
    const day = this.props.value.day;
    const month = this.props.value.month;
    const year = this.props.value.year;
    return (
      <Question>
        <Fieldset>
          <DateOfBirthLegend>
            {this.props.question ? this.props.question : "What is your date of birth?"}
            {this.props.hint ? this.props.hint : <Hint>For example, 31 08 1981</Hint>}
            {this.props.validationError ? <ErrorMessage>{this.props.validationError}</ErrorMessage> : null}
          </DateOfBirthLegend>
          <DateOfBirthField>
            <Label htmlFor="dateOfBirthDay">Day</Label>
            <Input
              id="dateOfBirthDay"
              data-testid="date-of-birth-day"
              className="dateOfBirthDay"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="bday-day"
              value={day}
              onChange={this.handleChange("day")}
              onBlur={this.handleBlur("day")}
              error={!!this.props.validationError}
            />
          </DateOfBirthField>
          <DateOfBirthField>
            <Label htmlFor="dateOfBirthMonth">Month</Label>
            <Input
              id="dateOfBirthMonth"
              data-testid="date-of-birth-month"
              className="dateOfBirthMonth"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="bday-month"
              value={month}
              onChange={this.handleChange("month")}
              onBlur={this.handleBlur("month")}
              error={!!this.props.validationError}
            />
          </DateOfBirthField>
          <DateOfBirthField>
            <Label htmlFor="dateOfBirthYear">Year</Label>
            <Input
              id="dateOfBirthYear"
              data-testid="date-of-birth-year"
              className="dateOfBirthYear"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="bday-year"
              value={year}
              onChange={this.handleChange("year")}
              onBlur={this.handleBlur("year")}
              error={!!this.props.validationError}
            />
          </DateOfBirthField>
        </Fieldset>
      </Question>
    );
  }
}

DateOfBirthQuestion.propTypes = {
  // render() reads value.day directly, so a missing value crashes rather than
  // renders blank. Both callers seed the three parts as empty strings.
  value: PropTypes.shape({
    day: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  // Curried. onChange(field) must return an event handler, and validate(field)
  // must return a function that takes the field value.
  onChange: PropTypes.func.isRequired,
  validate: PropTypes.func,
  question: PropTypes.node,
  hint: PropTypes.node,
  validationError: PropTypes.string,
};

export default DateOfBirthQuestion;
